import { render, staticRenderFns } from "./CowDeworming.vue?vue&type=template&id=08590e46&scoped=true&"
import script from "./CowDeworming.vue?vue&type=script&lang=js&"
export * from "./CowDeworming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08590e46",
  null
  
)

export default component.exports